module.exports = __webpack_public_path__ + "static/img/load_ajax.40f0d560.gif";